import http, { expandURI } from '@/utils/ajax'
import { ADMININSURED_INIT_LOADING, ADMININSURED_INIT_SUCCESS, ADMININSURED_INIT_FAIL, ADMININSURED_MENU_INIT_LOADING, ADMININSURED_MENU_INIT_SUCCESS, ADMININSURED_MENU_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'
const state = {
  init: 0,
  initErr: [],
  menu: {},
  insured: {
    init: 0,
    initErr: [],
    menu: {},
    insdRefNo: undefined,
    fullName: undefined,
    clientType: undefined,
    strCreatedBy: undefined,
    strModifiedBy: undefined
  }
}

const getters = {
}

const mutations = {
  [ADMININSURED_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [ADMININSURED_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [ADMININSURED_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [ADMININSURED_MENU_INIT_LOADING](state) {
    resetInsured(state)
  },
  [ADMININSURED_MENU_INIT_SUCCESS](state, data) {
    // Update menu
    state.insured.init = 1
    state.insured.initErr = []
    state.insured.menu = data.menu
    // data

    state.insured.insdRefNoAe = data.data.insdRefNoAe
    state.insured.insdRefNo = data.data.insdRefNo
    state.insured.clientGrp = data.data.clientGrp
    state.insured.clientType = data.data.clientType
    state.insured.titleName = data.data.titleName
    state.insured.name1 = data.data.name1
    state.insured.name2 = data.data.name2
    state.insured.name3 = data.data.name3
    state.insured.name4 = data.data.name4
    state.insured.fullName = data.data.fullName
    state.insured.abbrevName = data.data.abbrevName
    state.insured.address1 = data.data.address1
    state.insured.address2 = data.data.address2
    state.insured.address3 = data.data.address3
    state.insured.address4 = data.data.address4
    state.insured.address5 = data.data.address5
    state.insured.address6 = data.data.address6
    state.insured.postalCode = data.data.postalCode
    state.insured.contact = data.data.contact
    state.insured.telNo1 = data.data.telNo1
    state.insured.telNo2 = data.data.telNo2
    state.insured.telNo3 = data.data.telNo3
    state.insured.telNo4 = data.data.telNo4
    state.insured.telNo5 = data.data.telNo5
    state.insured.email = data.data.email
    state.insured.web = data.data.web
    state.insured.gender = data.data.gender
    state.insured.dob = data.data.dob
    state.insured.icNo = data.data.icNo
    state.insured.inactive = data.data.inactive
    state.insured.blackList = data.data.blackList
    state.insured.chgNAPol = data.data.chgNAPol
    state.insured.insdBillAcct = data.data.insdBillAcct
    state.insured.grpRefStmt = data.data.grpRefStmt
    state.insured.grpRefAge = data.data.grpRefAge
    state.insured.grpRefStats = data.data.grpRefStats
    state.insured.gstRegNo = data.data.gstRegNo
    state.insured.gstRegDate = data.data.gstRegDate
    state.insured.coRegNo = data.data.coRegNo
    state.insured.coRegDate = data.data.coRegDate
    state.insured.createdProgId = data.data.createdProgId
    state.insured.createdBy = data.data.createdBy
    state.insured.createdDate = data.data.createdDate
    state.insured.modifiedBy = data.data.modifiedBy
    state.insured.modifiedDate = data.data.modifiedDate

    state.insured.strCreatedBy = data.strCreatedBy
    state.insured.strModifiedBy = data.strModifiedBy
  },
  [ADMININSURED_MENU_INIT_FAIL](state, error) {
    state.insured.init = 2
    state.insured.initErr = error
    state.insured.menu = {}

    state.insured.strCreatedBy = ''
    state.insured.strModifiedBy = ''
  }
}

const actions = {
  async insuredsManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.insuredManagement
    commit(ADMININSURED_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(ADMININSURED_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(ADMININSURED_INIT_FAIL, extractMessages(error))
    }
  },
  async insuredMenuInit({ commit, state }, insdRefNo) {
    commit(ADMININSURED_MENU_INIT_LOADING)
    try {
      const apiURI = state.menu.getInsured
      const expand = {
        insdRefNo: insdRefNo
      }
      const result = await http.get(expandURI(apiURI, expand))
      const menu = extractMenu(result.data._links)
      const commitResult = {
        data: result.data.data.insured,
        strCreatedBy: result.data.data.strCreatedBy,
        strModifiedBy: result.data.data.strModifiedBy,
        menu: menu
      }
      commit(ADMININSURED_MENU_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(ADMININSURED_MENU_INIT_FAIL, extractMessages(error))
    }
  }
}
const resetInsured = (state) => {
  state.insured.init = 0
  state.insured.initErr = []
  state.insured.insdRefNo = undefined
  state.insured.fullName = undefined
  state.insured.clientType = undefined
}

export default {
  state,
  getters,
  mutations,
  actions
}
